export default "__VITE_ASSET__CLoOktAn__"